/** Canonical Toyotsu Lanka branch list — used for signup and poll/branch pickers. */
export const CANONICAL_BRANCHES: readonly string[] = [
  'Ampara',
  'Anuradhapura',
  'BPC Wattala',
  'Galle',
  'Gampaha',
  'Hino Centre - Wattala',
  'Hyde Park Corner',
  'Kalutara',
  'Kandy',
  'Kurunegala',
  'Maharagama',
  'Matara',
  'Negombo',
  'Nugegoda',
  'Panchikawatte',
  'Ratmalana',
  'Ratnapura',
  'Toyota Plaza - Wattala',
] as const;

/** Merge API/distinct branches with the canonical list, sorted for display. */
export function mergeBranchOptions(fromApi: string[]): string[] {
  const set = new Set<string>();
  for (const b of CANONICAL_BRANCHES) {
    const t = b.trim();
    if (t) set.add(t);
  }
  for (const b of fromApi) {
    const t = String(b || '').trim();
    if (t) set.add(t);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}
